import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody
} from "@/storybook-components";

const PopoverAction = ({ triggerIcon, content, ...rest }): JSX.Element => {
  return (
    <Popover placement="bottom-end" gutter={24}>
      <PopoverTrigger>{triggerIcon}</PopoverTrigger>
      <PopoverContent {...rest}>
        <PopoverBody p={0}>{content}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default PopoverAction;
